// import { Fetcher, Route, Token } from '@uniswap/sdk';
import { Fetcher as FetcherSpirit, Token as TokenSpirit } from '@pancakeswap/sdk';
import { Fetcher, Route, Token } from '@pancakeswap/sdk';
import { Configuration } from './config';
import {
  ContractName,
  TokenStat,
  AllocationTime,
  LPStat,
  Bank,
  PoolStats,
  TShareSwapperStat,
  PoolInfoStat,
  PoolUserInfoStat,
  RollStats,
  TossStats,
  RollStatsHistory,
  TossStatsHistory,
} from './types';
import { BigNumber, Contract, ethers, EventFilter } from 'ethers';
import { decimalToBalance } from './ether-utils';
import { TransactionResponse } from '@ethersproject/providers';
import ERC20 from './ERC20';
import { getBalance, getFullDisplayBalance, getDisplayBalance } from '../utils/formatBalance';
import { getDefaultProvider } from '../utils/provider';
import IUniswapV2PairABI from './IUniswapV2Pair.abi.json';
import config, { bankDefinitions } from '../config';
import moment from 'moment';
import { parseUnits } from 'ethers/lib/utils';
import { FTM_TICKER, SPOOKY_ROUTER_ADDR, TOMB_TICKER } from '../utils/constants';
// import MintModal from '../views/Mint/MintModal';
// import { faThList } from '@fortawesome/free-solid-svg-icons';
/**
 * An API module of HODLX contracts.
 * All contract-interacting domain logic should be defined in here.
 */
export class TombFinance {
  myAccount: string;
  provider: ethers.providers.Web3Provider;
  signer?: ethers.Signer;
  config: Configuration;
  contracts: { [name: string]: Contract };
  externalTokens: { [name: string]: ERC20 };
  masonryVersionOfUser?: string;

  TOMBWFTM_LP: Contract;
  TOMB: ERC20;
  TSHARE: ERC20;
  TBOND: ERC20;
  FTM: ERC20;
  CollectFlg: string;
  CollectedFlg: string;
  TsFailFlg: boolean;
  WelcomFlg: boolean;

  constructor(cfg: Configuration) {
    const { deployments, externalTokens } = cfg;
    const provider = getDefaultProvider();

    // loads contracts from deployments
    this.contracts = {};
    for (const [name, deployment] of Object.entries(deployments)) {
      this.contracts[name] = new Contract(deployment.address, deployment.abi, provider);
    }
    this.externalTokens = {};
    for (const [symbol, [address, decimal]] of Object.entries(externalTokens)) {
      this.externalTokens[symbol] = new ERC20(address, provider, symbol, decimal);
    }
    this.TOMB = new ERC20(deployments.tomb.address, provider, 'BNBX');
    this.TSHARE = new ERC20(deployments.tShare.address, provider, 'PNM');
    this.TBOND = new ERC20(deployments.tBond.address, provider, 'TBOND');
    this.FTM = this.externalTokens['WFTM'];
    // Uniswap V2 Pair
    this.TOMBWFTM_LP = new Contract(externalTokens['TOMB-FTM-LP'][0], IUniswapV2PairABI, provider);

    this.config = cfg;
    this.provider = provider;
    this.CollectFlg = 'NO';
    this.CollectedFlg = 'NO';
    this.TsFailFlg = false;
    this.WelcomFlg = true;
  }

  /**
   * @param provider From an unlocked wallet. (e.g. Metamask)
   * @param account An address of unlocked wallet account.
   */
  unlockWallet(provider: any, account: string) {
    const newProvider = new ethers.providers.Web3Provider(provider, this.config.chainId);
    this.signer = newProvider.getSigner(0);
    this.myAccount = account;
    this.WelcomFlg = false;
    for (const [name, contract] of Object.entries(this.contracts)) {
      this.contracts[name] = contract.connect(this.signer);
    }
    const tokens = [this.TOMB, this.TSHARE, this.TBOND, ...Object.values(this.externalTokens)];
    for (const token of tokens) {
      token.connect(this.signer);
    }
    this.TOMBWFTM_LP = this.TOMBWFTM_LP.connect(this.signer);
    console.log(`🔓 Wallet is unlocked. Welcome, ${account}!`);
    this.fetchMasonryVersionOfUser()
      .then((version) => (this.masonryVersionOfUser = version))
      .catch((err) => {
        console.error(`Failed to fetch masonry version: ${err.stack}`);
        this.masonryVersionOfUser = 'latest';
      });
  }

  ResetCollectFlg() {
    this.CollectFlg = 'YES';
    return;
  }

  get isUnlocked(): boolean {
    return !!this.myAccount;
  }

  //===================================================================
  //===================== GET ASSET STATS =============================
  //===================FROM SPOOKY TO DISPLAY =========================
  //=========================IN HOME PAGE==============================
  //===================================================================

  async getTombStat(): Promise<TokenStat> {
    const { TombFtmRewardPool, TombFtmLpTombRewardPool, TombFtmLpTombRewardPoolOld } = this.contracts;
    const supply = await this.TOMB.totalSupply();
    const tombRewardPoolSupply = await this.TOMB.balanceOf(TombFtmRewardPool.address);
    const tombRewardPoolSupply2 = await this.TOMB.balanceOf(TombFtmLpTombRewardPool.address);
    const tombRewardPoolSupplyOld = await this.TOMB.balanceOf(TombFtmLpTombRewardPoolOld.address);
    const tombCirculatingSupply = supply
      .sub(tombRewardPoolSupply)
      .sub(tombRewardPoolSupply2)
      .sub(tombRewardPoolSupplyOld);
    const priceInFTM = await this.getTokenPriceFromPancakeswap(this.TOMB);
    const priceOfOneFTM = await this.getWFTMPriceFromPancakeswap();
    // const priceOfTombInDollars = (Number(priceInFTM) * Number(priceOfOneFTM)).toFixed(2);
    const priceOfTombInDollars = (Number(priceInFTM) * Number(priceOfOneFTM)).toFixed(18);

    return {
      tokenInFtm: priceInFTM,
      priceInDollars: priceOfTombInDollars,
      totalSupply: getDisplayBalance(supply, this.TOMB.decimal, 0),
      circulatingSupply: getDisplayBalance(tombCirculatingSupply, this.TOMB.decimal, 0),
    };
  }

  /**
   * Calculates various stats for the requested LP
   * @param name of the LP token to load stats for
   * @returns
   */
  async getLPStat(name: string): Promise<LPStat> {
    const lpToken = this.externalTokens[name];
    const lpTokenSupplyBN = await lpToken.totalSupply();
    const lpTokenSupply = getDisplayBalance(lpTokenSupplyBN, 18);
    const token0 = name.startsWith('TOMB') ? this.TOMB : this.TSHARE;
    const isTomb = name.startsWith('TOMB');
    const tokenAmountBN = await token0.balanceOf(lpToken.address);
    const tokenAmount = getDisplayBalance(tokenAmountBN, 18);

    const ftmAmountBN = await this.FTM.balanceOf(lpToken.address);
    const ftmAmount = getDisplayBalance(ftmAmountBN, 18);
    const tokenAmountInOneLP = Number(tokenAmount) / Number(lpTokenSupply);
    const ftmAmountInOneLP = Number(ftmAmount) / Number(lpTokenSupply);
    const lpTokenPrice = await this.getLPTokenPrice(lpToken, token0, isTomb);
    const lpTokenPriceFixed = Number(lpTokenPrice).toFixed(18).toString();
    const liquidity = (Number(lpTokenSupply) * Number(lpTokenPrice)).toFixed(2).toString();
    return {
      tokenAmount: tokenAmountInOneLP.toString(),
      ftmAmount: ftmAmountInOneLP.toString(),
      priceOfOne: lpTokenPriceFixed,
      totalLiquidity: liquidity,
      totalSupply: Number(lpTokenSupply).toFixed(2).toString(),
    };
  }

  /**
   * Use this method to get price for Tomb
   * @returns TokenStat for TBOND
   * priceInFTM
   * priceInDollars
   * TotalSupply
   * CirculatingSupply (always equal to total supply for bonds)
   */
  async getBondStat(): Promise<TokenStat> {
    const { Treasury } = this.contracts;
    const tombStat = await this.getTombStat();
    const bondTombRatioBN = await Treasury.getBondPremiumRate();
    const modifier = bondTombRatioBN / 1e18 > 1 ? bondTombRatioBN / 1e18 : 1;
    const bondPriceInFTM = (Number(tombStat.tokenInFtm) * modifier).toFixed(2);
    const priceOfTBondInDollars = (Number(tombStat.priceInDollars) * modifier).toFixed(2);
    const supply = await this.TBOND.displayedTotalSupply();
    return {
      tokenInFtm: bondPriceInFTM,
      priceInDollars: priceOfTBondInDollars,
      totalSupply: supply,
      circulatingSupply: supply,
    };
  }

  /**
   * @returns TokenStat for TSHARE
   * priceInFTM
   * priceInDollars
   * TotalSupply
   * CirculatingSupply (always equal to total supply for bonds)
   */
  async getShareStat(): Promise<TokenStat> {
    const { Reserve, DevFund, DaoFund, TreasuryFund, Staking } = this.contracts;

    const supply = await this.TSHARE.totalSupply();

    const priceInFTM = await this.getTokenPriceFromPancakeswap(this.TSHARE);
    const ReserveSupply = await this.TSHARE.balanceOf(Reserve.address);
    const DevFundSupply = await this.TSHARE.balanceOf(DevFund.address);
    const DaoFundSupply = await this.TSHARE.balanceOf(DaoFund.address);
    const StakingSupply = await this.TSHARE.balanceOf(Staking.address);
    const TreasuryFundSupply = await this.TSHARE.balanceOf(TreasuryFund.address);
    const tShareCirculatingSupply = supply
      .sub(ReserveSupply)
      .sub(DevFundSupply)
      .sub(DaoFundSupply)
      .sub(TreasuryFundSupply)
      .sub(StakingSupply);
    const priceOfOneFTM = await this.getWFTMPriceFromPancakeswap();
    const priceOfSharesInDollars = (Number(priceInFTM) * Number(priceOfOneFTM)).toFixed(18);

    return {
      tokenInFtm: priceInFTM,
      priceInDollars: priceOfSharesInDollars,
      totalSupply: getDisplayBalance(supply, this.TSHARE.decimal, 0),
      circulatingSupply: getDisplayBalance(tShareCirculatingSupply, this.TSHARE.decimal, 0),
    };
  }

  async getTombStatInEstimatedTWAP(): Promise<TokenStat> {
    const { SeigniorageOracle, TombFtmRewardPool } = this.contracts;
    const expectedPrice = await SeigniorageOracle.twap(this.TOMB.address, ethers.utils.parseEther('1'));

    const supply = await this.TOMB.totalSupply();
    const tombRewardPoolSupply = await this.TOMB.balanceOf(TombFtmRewardPool.address);
    const tombCirculatingSupply = supply.sub(tombRewardPoolSupply);
    return {
      tokenInFtm: getDisplayBalance(expectedPrice),
      priceInDollars: getDisplayBalance(expectedPrice),
      totalSupply: getDisplayBalance(supply, this.TOMB.decimal, 0),
      circulatingSupply: getDisplayBalance(tombCirculatingSupply, this.TOMB.decimal, 0),
    };
  }

  async getTombPriceInLastTWAP(): Promise<BigNumber> {
    const { Treasury } = this.contracts;
    return Treasury.getTombUpdatedPrice();
  }

  async getBondsPurchasable(): Promise<BigNumber> {
    const { Treasury } = this.contracts;
    return Treasury.getBurnableTombLeft();
  }

  /**
   * Calculates the TVL, APR and daily APR of a provided pool/bank
   * @param bank
   * @returns
   */
  async getPoolAPRs(bank: Bank): Promise<PoolStats> {
    // if (this.myAccount === undefined) return;
    const depositToken = bank.depositToken;
    const poolContract = this.contracts[bank.contract];
    const depositTokenPrice = await this.getDepositTokenPriceInDollars(bank.depositTokenName, depositToken);
    const stakeInPool = await depositToken.balanceOf(bank.address);
    const TVL = Number(depositTokenPrice) * Number(getDisplayBalance(stakeInPool, depositToken.decimal));

    const stat = bank.earnTokenName === 'TOMB' ? await this.getTombStat() : await this.getShareStat();
    let tokenPerSecond = await this.getTokenPerSecond(
      bank.earnTokenName,
      bank.contract,
      poolContract,
      bank.depositTokenName,
    );

    const tokenPerHour = tokenPerSecond.mul(60).mul(60);
    const tokenPerDay = Number(getDisplayBalance(tokenPerHour.mul(24)));
    const totalRewardPricePerYear =
      Number(stat.priceInDollars) * Number(getDisplayBalance(tokenPerHour.mul(24).mul(365)));
    const totalRewardPricePerDay = Number(stat.priceInDollars) * Number(getDisplayBalance(tokenPerHour.mul(24)));
    const totalStakingTokenInPool =
      Number(depositTokenPrice) * Number(getDisplayBalance(stakeInPool, depositToken.decimal));
    const dailyAPR = (totalRewardPricePerDay / totalStakingTokenInPool) * 100;
    const yearlyAPR = (totalRewardPricePerYear / totalStakingTokenInPool) * 100;
    return {
      tokenPerDay: tokenPerDay.toFixed(0).toString(),
      dailyAPR: dailyAPR.toFixed(2).toString(),
      yearlyAPR: yearlyAPR.toFixed(2).toString(),
      TVL: TVL.toFixed(0).toString(),
    };
  }

  /**
   * Method to return the amount of tokens the pool yields per second
   * @param earnTokenName the name of the token that the pool is earning
   * @param contractName the contract of the pool/bank
   * @param poolContract the actual contract of the pool
   * @returns
   */
  async getTokenPerSecond(
    earnTokenName: string,
    contractName: string,
    poolContract: Contract,
    depositTokenName: string,
  ) {
    if (earnTokenName === 'TOMB') {
      if (!contractName.endsWith('TombRewardPool')) {
        const rewardPerSecond = await poolContract.tombPerSecond();
        if (depositTokenName === 'WFTM') {
          return rewardPerSecond.mul(6000).div(11000).div(24);
        } else if (depositTokenName === 'BOO') {
          return rewardPerSecond.mul(2500).div(11000).div(24);
        } else if (depositTokenName === 'ZOO') {
          return rewardPerSecond.mul(1000).div(11000).div(24);
        } else if (depositTokenName === 'SHIBA') {
          return rewardPerSecond.mul(1500).div(11000).div(24);
        }
        return rewardPerSecond.div(24);
      }
      const poolStartTime = await poolContract.poolStartTime();
      const startDateTime = new Date(poolStartTime.toNumber() * 1000);
      const FOUR_DAYS = 4 * 24 * 60 * 60 * 1000;
      if (Date.now() - startDateTime.getTime() > FOUR_DAYS) {
        return await poolContract.epochTombPerSecond(1);
      }
      return await poolContract.epochTombPerSecond(0);
    }
    let rewardPerSecond = await poolContract.rewardPerSecond();
    // if (rewardPerSecond == 0) {
    //   rewardPerSecond = BigNumber.from('65493055555556000');
    // }

    if (depositTokenName.startsWith('TOMB')) {
      return rewardPerSecond.mul(70000).div(100000);
    } else {
      return rewardPerSecond.mul(30000).div(100000);
    }
  }

  /**
   * Method to calculate the tokenPrice of the deposited asset in a pool/bank
   * If the deposited token is an LP it will find the price of its pieces
   * @param tokenName
   * @param pool
   * @param token
   * @returns
   */
  async getDepositTokenPriceInDollars(tokenName: string, token: ERC20) {
    let tokenPrice;
    const priceOfOneFtmInDollars = await this.getWFTMPriceFromPancakeswap();
    if (tokenName === 'WFTM') {
      tokenPrice = priceOfOneFtmInDollars;
    } else {
      if (tokenName === 'TOMB-FTM-LP') {
        tokenPrice = await this.getLPTokenPrice(token, this.TOMB, true);
      } else if (tokenName === 'TSHARE-FTM-LP') {
        tokenPrice = await this.getLPTokenPrice(token, this.TSHARE, false);
      } else if (tokenName === 'SHIBA') {
        tokenPrice = await this.getTokenPriceFromSpiritswap(token);
      } else {
        tokenPrice = await this.getTokenPriceFromPancakeswap(token);
        tokenPrice = (Number(tokenPrice) * Number(priceOfOneFtmInDollars)).toString();
      }
    }
    return tokenPrice;
  }

  //===================================================================
  //===================== GET ASSET STATS =============================
  //=========================== END ===================================
  //===================================================================

  async getCurrentEpoch(): Promise<BigNumber> {
    const { Treasury } = this.contracts;
    return Treasury.epoch();
  }

  async getBondOraclePriceInLastTWAP(): Promise<BigNumber> {
    const { Treasury } = this.contracts;
    return Treasury.getBondPremiumRate();
  }

  /**
   * Buy bonds with cash.
   * @param amount amount of cash to purchase bonds with.
   */
  async buyBonds(amount: string | number): Promise<TransactionResponse> {
    const { Treasury } = this.contracts;
    const treasuryTombPrice = await Treasury.getTombPrice();
    return await Treasury.buyBonds(decimalToBalance(amount), treasuryTombPrice);
  }

  /**
   * Redeem bonds for cash.
   * @param amount amount of bonds to redeem.
   */
  async redeemBonds(amount: string): Promise<TransactionResponse> {
    const { Treasury } = this.contracts;
    const priceForTomb = await Treasury.getTombPrice();
    return await Treasury.redeemBonds(decimalToBalance(amount), priceForTomb);
  }

  async getTotalValueLocked(): Promise<Number> {
    let FarmTVL = 0;
    for (const bankInfo of Object.values(bankDefinitions)) {
      const pool = this.contracts[bankInfo.contract];
      const token = this.externalTokens[bankInfo.depositTokenName];
      const tokenPrice = await this.getDepositTokenPriceInDollars(bankInfo.depositTokenName, token);
      const tokenAmountInPool = await token.balanceOf(pool.address);
      const value = Number(getDisplayBalance(tokenAmountInPool, token.decimal)) * Number(tokenPrice);
      const poolValue = Number.isNaN(value) ? 0 : value;
      FarmTVL += poolValue;
    }

    const { MintRedeemPool } = this.contracts;

    const TSHAREPrice = (await this.getShareStat()).priceInDollars;
    const FTMPrice = await this.getWFTMPriceFromPancakeswap();
    const stakingtShareBalanceOf = (await this.getTotalStackedOnStaking()).add(await this.getLockedSupplyOnStaking());
    const stakingTVL = Number(getDisplayBalance(stakingtShareBalanceOf, this.TSHARE.decimal)) * Number(TSHAREPrice);

    const poolFtmBalanceOf = await this.FTM.balanceOf(MintRedeemPool.address);
    const poolTVL = Number(getDisplayBalance(poolFtmBalanceOf, this.FTM.decimal)) * Number(FTMPrice);

    return FarmTVL + stakingTVL + poolTVL;
  }

  /**
   * Calculates the price of an LP token
   * Reference https://github.com/DefiDebauchery/discordpricebot/blob/4da3cdb57016df108ad2d0bb0c91cd8dd5f9d834/pricebot/pricebot.py#L150
   * @param lpToken the token under calculation
   * @param token the token pair used as reference (the other one would be FTM in most cases)
   * @param isTomb sanity check for usage of tomb token or tShare
   * @returns price of the LP token
   */
  async getLPTokenPrice(lpToken: ERC20, token: ERC20, isTomb: boolean): Promise<string> {
    const totalSupply = await lpToken.totalSupply();
    //Get amount of tokenA
    const tokenSupply = await token.balanceOf(lpToken.address);
    const stat = isTomb === true ? await this.getTombStat() : await this.getShareStat();
    const priceOfToken = stat.priceInDollars;
    const tokenInLP =
      (Number(tokenSupply) / Number(totalSupply) / Math.pow(10, token.decimal)) * Math.pow(10, lpToken.decimal);
    const tokenPrice = (Number(priceOfToken) * tokenInLP * 2) //We multiply by 2 since half the price of the lp token is the price of each piece of the pair. So twice gives the total
      .toString();
    return tokenPrice;
  }

  async earnedFromBank(
    poolName: ContractName,
    earnTokenName: String,
    poolId: Number,
    account = this.myAccount,
  ): Promise<BigNumber> {
    const pool = this.contracts[poolName];
    try {
      if (earnTokenName === 'TOMB') {
        return await pool.pendingTOMB(poolId, account);
      } else {
        return await pool.pendingReward(poolId, account);
      }
    } catch (err) {
      console.error(`Failed to call earned() on pool ${pool.address}: ${err.stack}`);
      return BigNumber.from(0);
    }
  }

  async stakedBalanceOnBank(poolName: ContractName, poolId: Number, account = this.myAccount): Promise<BigNumber> {
    const pool = this.contracts[poolName];
    try {
      let userInfo = await pool.userInfo(poolId, account);
      return await userInfo.amount;
    } catch (err) {
      console.error(`Failed to call balanceOf() on pool ${pool.address}: ${err.stack}`);
      return BigNumber.from(0);
    }
  }

  /**
   * Deposits token to given pool.
   * @param poolName A name of pool contract.
   * @param amount Number of tokens with decimals applied. (e.g. 1.45 DAI * 10^18)
   * @returns {string} Transaction hash
   */
  async stake(
    poolName: ContractName,
    poolId: Number,
    amount: BigNumber,
    myAccount: string,
  ): Promise<TransactionResponse> {
    const pool = this.contracts[poolName];
    return await pool.deposit(poolId, amount, myAccount);
  }

  async stakeOnStaking(amount: BigNumber, lock: boolean): Promise<TransactionResponse> {
    const { Staking } = this.contracts;
    return await Staking.stake(amount, lock);
  }

  async withdraw(amount: BigNumber): Promise<TransactionResponse> {
    const { Staking } = this.contracts;
    return await Staking.withdraw(amount);
  }

  async getClaimableBalance(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return await Staking.unlockedBalance(myAccount);
  }

  async getEarnedBalance(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return (await Staking.earnedBalances(myAccount)).total;
  }

  async getEarnedData(myAccount: string) {
    const { Staking } = this.contracts;
    return (await Staking.earnedBalances(myAccount)).earningsData;
  }

  async getWithdrawBalance(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return (await Staking.withdrawableBalance(myAccount)).amount;
  }

  async getPenaltyBalance(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return (await Staking.withdrawableBalance(myAccount)).penaltyAmount;
  }

  async getExpiredLockedBalance(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return (await Staking.lockedBalances(myAccount)).unlockable;
  }

  async getLockData(myAccount: string) {
    const { Staking } = this.contracts;
    return (await Staking.lockedBalances(myAccount)).lockData;
  }

  async getLocked(myAccount: string): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return (await Staking.lockedBalances(myAccount)).locked;
  }

  async getClaimableFees(myAccount: string) {
    const { Staking } = this.contracts;
    return await Staking.claimableRewards(myAccount);
  }

  async getCR(): Promise<BigNumber> {
    const { MintRedeemPool } = this.contracts;
    return await MintRedeemPool.collateralRatio();
  }

  async getLastRefreshCrTimestamp(): Promise<BigNumber> {
    const { MintRedeemPool } = this.contracts;
    return await MintRedeemPool.lastRefreshCrTimestamp();
  }

  async getXTokenTWAP(): Promise<BigNumber> {
    const { MasterOracle } = this.contracts;
    return await MasterOracle.getXTokenTWAP();
  }

  async getBlockTimestampLast(): Promise<BigNumber> {
    const { UniswapPairOracle } = this.contracts;
    return await UniswapPairOracle.blockTimestampLast();
  }

  /**
   * Withdraws token from given pool.
   * @param poolName A name of pool contract.
   * @param amount Number of tokens with decimals applied. (e.g. 1.45 DAI * 10^18)
   * @returns {string} Transaction hash
   */
  async unstake(
    poolName: ContractName,
    poolId: Number,
    amount: BigNumber,
    myAccount: string,
  ): Promise<TransactionResponse> {
    const pool = this.contracts[poolName];
    return await pool.withdraw(poolId, amount, myAccount);
  }

  /**
   * Transfers earned token reward from given pool to my account.
   */
  async harvest(poolName: ContractName, poolId: Number, myAccount: string): Promise<TransactionResponse> {
    const pool = this.contracts[poolName];

    //By passing 0 as the amount, we are asking the contract to only redeem the reward and not the currently staked token
    return await pool.harvest(poolId, myAccount);
  }

  async harvestall(poolName: ContractName, myAccount: string): Promise<TransactionResponse> {
    const pool = this.contracts[poolName];

    //By passing 0 as the amount, we are asking the contract to only redeem the reward and not the currently staked token
    return await pool.harvestAllRewards(myAccount);
  }

  /**
   * Harvests and withdraws deposited tokens from the pool.
   */
  async exit(poolName: ContractName, poolId: Number, account = this.myAccount): Promise<TransactionResponse> {
    const pool = this.contracts[poolName];
    let userInfo = await pool.userInfo(poolId, account);
    return await pool.withdrawAndHarvest(poolId, userInfo.amount, account);
  }

  async fetchMasonryVersionOfUser(): Promise<string> {
    return 'latest';
  }

  currentMasonry(): Contract {
    if (!this.masonryVersionOfUser) {
      //throw new Error('you must unlock the wallet to continue.');
    }
    return this.contracts.Masonry;
  }

  isOldMasonryMember(): boolean {
    return this.masonryVersionOfUser !== 'latest';
  }

  async getTokenPriceFromPancakeswap(tokenContract: ERC20): Promise<string> {
    const ready = await this.provider.ready;
    if (!ready) return;
    const { chainId } = this.config;
    const { WFTM } = this.config.externalTokens;

    const wftm = new Token(chainId, WFTM[0], WFTM[1]);
    const token = new Token(chainId, tokenContract.address, tokenContract.decimal, tokenContract.symbol);
    try {
      const wftmToToken = await Fetcher.fetchPairData(wftm, token, this.provider);
      const priceInBUSD = new Route([wftmToToken], token);

      return priceInBUSD.midPrice.toFixed(18);
    } catch (err) {
      console.error(`Failed to fetch token price of ${tokenContract.symbol}: ${err}`);
    }
  }

  async getTokenPriceFromSpiritswap(tokenContract: ERC20): Promise<string> {
    const ready = await this.provider.ready;
    if (!ready) return;
    const { chainId } = this.config;

    const { WFTM } = this.externalTokens;

    const wftm = new TokenSpirit(chainId, WFTM.address, WFTM.decimal);
    const token = new TokenSpirit(chainId, tokenContract.address, tokenContract.decimal, tokenContract.symbol);
    try {
      const wftmToToken = await FetcherSpirit.fetchPairData(wftm, token, this.provider);
      const liquidityToken = wftmToToken.liquidityToken;
      let ftmBalanceInLP = await WFTM.balanceOf(liquidityToken.address);
      let ftmAmount = Number(getFullDisplayBalance(ftmBalanceInLP, WFTM.decimal));
      let shibaBalanceInLP = await tokenContract.balanceOf(liquidityToken.address);
      let shibaAmount = Number(getFullDisplayBalance(shibaBalanceInLP, tokenContract.decimal));
      const priceOfOneFtmInDollars = await this.getWFTMPriceFromPancakeswap();
      let priceOfShiba = (ftmAmount / shibaAmount) * Number(priceOfOneFtmInDollars);
      return priceOfShiba.toString();
    } catch (err) {
      console.error(`Failed to fetch token price of ${tokenContract.symbol}: ${err}`);
    }
  }

  async getWFTMPriceFromPancakeswap(): Promise<string> {
    const ready = await this.provider.ready;
    if (!ready) return;
    const { WFTM, FUSDT } = this.externalTokens;
    try {
      const fusdt_wftm_lp_pair = this.externalTokens['USDT-FTM-LP'];
      let ftm_amount_BN = await WFTM.balanceOf(fusdt_wftm_lp_pair.address);
      let ftm_amount = Number(getBalance(ftm_amount_BN, WFTM.decimal));
      let fusdt_amount_BN = await FUSDT.balanceOf(fusdt_wftm_lp_pair.address);
      let fusdt_amount = Number(getBalance(fusdt_amount_BN, FUSDT.decimal));
      return (fusdt_amount / ftm_amount).toString();
    } catch (err) {
      console.error(`Failed to fetch token price of WFTM: ${err}`);
    }
  }

  //===================================================================
  //===================================================================
  //===================== MASONRY METHODS =============================
  //===================================================================
  //===================================================================

  async getMasonryAPR() {
    const Masonry = this.currentMasonry();
    const latestSnapshotIndex = await Masonry.latestSnapshotIndex();
    const lastHistory = await Masonry.masonryHistory(latestSnapshotIndex);

    const lastRewardsReceived = lastHistory[1];

    const TSHAREPrice = (await this.getShareStat()).priceInDollars;
    const TOMBPrice = (await this.getTombStat()).priceInDollars;
    const epochRewardsPerShare = lastRewardsReceived / 1e18;

    //Mgod formula
    const amountOfRewardsPerDay = epochRewardsPerShare * Number(TOMBPrice) * 4;
    const masonrytShareBalanceOf = await this.TSHARE.balanceOf(Masonry.address);
    const masonryTVL = Number(getDisplayBalance(masonrytShareBalanceOf, this.TSHARE.decimal)) * Number(TSHAREPrice);
    const realAPR = ((amountOfRewardsPerDay * 100) / masonryTVL) * 365;
    return realAPR;
  }

  /**
   * Checks if the user is allowed to retrieve their reward from the Masonry
   * @returns true if user can withdraw reward, false if they can't
   */
  async canUserClaimRewardFromMasonry(): Promise<boolean> {
    const Masonry = this.currentMasonry();
    return await Masonry.canClaimReward(this.myAccount);
  }

  /**
   * Checks if the user is allowed to retrieve their reward from the Masonry
   * @returns true if user can withdraw reward, false if they can't
   */
  async canUserUnstakeFromMasonry(): Promise<boolean> {
    const Masonry = this.currentMasonry();
    const canWithdraw = await Masonry.canWithdraw(this.myAccount);
    const stakedAmount = await this.getStakedSharesOnMasonry();
    const notStaked = Number(getDisplayBalance(stakedAmount, this.TSHARE.decimal)) === 0;
    const result = notStaked ? true : canWithdraw;
    return result;
  }

  async timeUntilClaimRewardFromMasonry(): Promise<BigNumber> {
    // const Masonry = this.currentMasonry();
    // const mason = await Masonry.masons(this.myAccount);
    return BigNumber.from(0);
  }

  async getTotalStakedInMasonry(): Promise<BigNumber> {
    const Masonry = this.currentMasonry();
    return await Masonry.totalSupply();
  }

  async stakeShareToMasonry(amount: string): Promise<TransactionResponse> {
    if (this.isOldMasonryMember()) {
      throw new Error("you're using old masonry. please withdraw and deposit the TSHARE again.");
    }
    const Masonry = this.currentMasonry();
    return await Masonry.stake(decimalToBalance(amount));
  }

  async getStakedSharesOnMasonry(): Promise<BigNumber> {
    const Masonry = this.currentMasonry();
    if (this.masonryVersionOfUser === 'v1') {
      return await Masonry.getShareOf(this.myAccount);
    }
    return await Masonry.balanceOf(this.myAccount);
  }

  async getLockedSupplyOnStaking(): Promise<BigNumber> {
    const { Staking } = this.contracts;
    return await Staking.lockedSupply();
  }

  async getTotalStackedOnStaking(): Promise<BigNumber> {
    const { Staking } = this.contracts;
    const total = await Staking.totalSupply();
    const locked = await Staking.lockedSupply();
    return total.sub(locked);
  }

  async getAccFee(): Promise<BigNumber> {
    const { FsmTreasury } = this.contracts;
    return await this.FTM.balanceOf(FsmTreasury.address);
  }

  async getStakingAPR() {
    const { Staking, MasterOracle } = this.contracts;
    const rewardRate = (await Staking.rewardData(this.FTM.address)).rewardRate;
    const totalSupply = await Staking.totalSupply();
    const yTokenPrice = await MasterOracle.getYTokenPrice();
    const apr = ((Number(rewardRate) * 86400 * 365) / Number(totalSupply) / yTokenPrice) * Math.pow(10, 18) * 100;
    return apr;
  }

  async getLockingAPR() {
    const { tShare, Staking } = this.contracts;
    const rewardRate = (await Staking.rewardData(tShare.address)).rewardRate;
    const lockedSupply = await Staking.lockedSupply();
    const stakingAPR = await this.getStakingAPR();
    const apr = ((Number(rewardRate) * 86400 * 365) / Number(lockedSupply)) * 100 + Number(stakingAPR);
    return apr;
  }

  async getEarningsOnMasonry(): Promise<BigNumber> {
    const Masonry = this.currentMasonry();
    if (this.masonryVersionOfUser === 'v1') {
      return await Masonry.getCashEarningsOf(this.myAccount);
    }
    return await Masonry.earned(this.myAccount);
  }

  async withdrawShareFromMasonry(amount: string): Promise<TransactionResponse> {
    const Masonry = this.currentMasonry();
    return await Masonry.withdraw(decimalToBalance(amount));
  }

  async withdrawShareFromStaking(amount: string): Promise<TransactionResponse> {
    const { Staking } = this.contracts;
    return await Staking.withdraw(decimalToBalance(amount));
  }

  async withdrawExpiredLocks(): Promise<TransactionResponse> {
    const { Staking } = this.contracts;
    return await Staking.withdrawExpiredLocks();
  }

  async getReward(): Promise<TransactionResponse> {
    const { Staking } = this.contracts;
    return await Staking.getReward();
  }

  async harvestCashFromMasonry(): Promise<TransactionResponse> {
    const Masonry = this.currentMasonry();
    if (this.masonryVersionOfUser === 'v1') {
      return await Masonry.claimDividends();
    }
    return await Masonry.claimReward();
  }

  async exitFromMasonry(): Promise<TransactionResponse> {
    const Masonry = this.currentMasonry();
    return await Masonry.exit();
  }

  async getTreasuryNextAllocationTime(): Promise<AllocationTime> {
    const { Treasury } = this.contracts;
    const nextEpochTimestamp: BigNumber = await Treasury.nextEpochPoint();
    const nextAllocation = new Date(nextEpochTimestamp.mul(1000).toNumber());
    const prevAllocation = new Date(Date.now());

    return { from: prevAllocation, to: nextAllocation };
  }
  /**
   * This method calculates and returns in a from to to format
   * the period the user needs to wait before being allowed to claim
   * their reward from the masonry
   * @returns Promise<AllocationTime>
   */
  async getUserClaimRewardTime(): Promise<AllocationTime> {
    const { Masonry, Treasury } = this.contracts;
    const nextEpochTimestamp = await Masonry.nextEpochPoint(); //in unix timestamp
    const currentEpoch = await Masonry.epoch();
    const mason = await Masonry.masons(this.myAccount);
    const startTimeEpoch = mason.epochTimerStart;
    const period = await Treasury.PERIOD();
    const periodInHours = period / 60 / 60; // 6 hours, period is displayed in seconds which is 21600
    const rewardLockupEpochs = await Masonry.rewardLockupEpochs();
    const targetEpochForClaimUnlock = Number(startTimeEpoch) + Number(rewardLockupEpochs);

    const fromDate = new Date(Date.now());
    if (targetEpochForClaimUnlock - currentEpoch <= 0) {
      return { from: fromDate, to: fromDate };
    } else if (targetEpochForClaimUnlock - currentEpoch === 1) {
      const toDate = new Date(nextEpochTimestamp * 1000);
      return { from: fromDate, to: toDate };
    } else {
      const toDate = new Date(nextEpochTimestamp * 1000);
      const delta = targetEpochForClaimUnlock - currentEpoch - 1;
      const endDate = moment(toDate)
        .add(delta * periodInHours, 'hours')
        .toDate();
      return { from: fromDate, to: endDate };
    }
  }

  /**
   * This method calculates and returns in a from to to format
   * the period the user needs to wait before being allowed to unstake
   * from the masonry
   * @returns Promise<AllocationTime>
   */
  async getUserUnstakeTime(): Promise<AllocationTime> {
    const { Masonry, Treasury } = this.contracts;
    const nextEpochTimestamp = await Masonry.nextEpochPoint();
    const currentEpoch = await Masonry.epoch();
    const mason = await Masonry.masons(this.myAccount);
    const startTimeEpoch = mason.epochTimerStart;
    const period = await Treasury.PERIOD();
    const PeriodInHours = period / 60 / 60;
    const withdrawLockupEpochs = await Masonry.withdrawLockupEpochs();
    const fromDate = new Date(Date.now());
    const targetEpochForClaimUnlock = Number(startTimeEpoch) + Number(withdrawLockupEpochs);
    const stakedAmount = await this.getStakedSharesOnMasonry();
    if (currentEpoch <= targetEpochForClaimUnlock && Number(stakedAmount) === 0) {
      return { from: fromDate, to: fromDate };
    } else if (targetEpochForClaimUnlock - currentEpoch === 1) {
      const toDate = new Date(nextEpochTimestamp * 1000);
      return { from: fromDate, to: toDate };
    } else {
      const toDate = new Date(nextEpochTimestamp * 1000);
      const delta = targetEpochForClaimUnlock - Number(currentEpoch) - 1;
      const endDate = moment(toDate)
        .add(delta * PeriodInHours, 'hours')
        .toDate();
      return { from: fromDate, to: endDate };
    }
  }

  async watchAssetInMetamask(assetName: string): Promise<boolean> {
    const { ethereum } = window as any;
    const host = window.location.origin;
    if (ethereum && ethereum.networkVersion === config.chainId.toString()) {
      let asset;
      let assetUrl;
      if (assetName === 'TOMB') {
        asset = this.TOMB;
        assetUrl = `${host}/tomb.png`;
      } else if (assetName === 'TSHARE') {
        asset = this.TSHARE;
        assetUrl = `${host}/tshare.png`;
      }
      await ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: asset.address,
            symbol: asset.symbol,
            decimals: 18,
            image: assetUrl,
          },
        },
      });
    }
    return true;
  }

  async provideTombFtmLP(ftmAmount: string, tombAmount: BigNumber): Promise<TransactionResponse> {
    const { TaxOffice } = this.contracts;
    let overrides = {
      value: parseUnits(ftmAmount, 18),
    };
    return await TaxOffice.addLiquidityETHTaxFree(
      tombAmount,
      tombAmount.mul(992).div(1000),
      parseUnits(ftmAmount, 18).mul(992).div(1000),
      overrides,
    );
  }

  async poolmint(ftmAmount: string, mimtombAmount: string): Promise<TransactionResponse> {
    const { MintRedeemPool } = this.contracts;
    // depositTx = await presale.deposit({value:ethers.utils.parseUnits(value, "ether"), gasLimit:360000});
    // return await MintRedeemPool.mint( parseUnits(mimtombAmount, 18) , {value:ethers.utils.parseUnits(ftmAmount, "ether")} );

    let mintTx = await MintRedeemPool.mint(parseUnits(String(mimtombAmount), 18), { value: parseUnits(ftmAmount, 18) });
    await mintTx.wait();
    this.CollectFlg = 'YES';
    let collectTx = await MintRedeemPool.collect();
    await collectTx.wait();
    this.CollectedFlg = 'YES';
    return collectTx;
  }

  async poolCollect(): Promise<TransactionResponse> {
    const { MintRedeemPool } = this.contracts;
    // depositTx = await presale.deposit({value:ethers.utils.parseUnits(value, "ether"), gasLimit:360000});
    return await MintRedeemPool.collect();
    // return await MintRedeemPool.mint( parseUnits(mimtombAmount, 18) , {value:ethers.utils.parseUnits(ftmAmount, "ether")} );
  }

  async poolredeem(tombAmount: string, mimftmAmount: string, mimfxmAmount: string): Promise<TransactionResponse> {
    const { MintRedeemPool } = this.contracts;
    let redeemTx = await MintRedeemPool.redeem(
      parseUnits(tombAmount, 18),
      parseUnits(String(mimfxmAmount), 18),
      parseUnits(String(mimftmAmount), 18),
    );
    await redeemTx.wait();
    this.CollectFlg = 'YES';
    let collectTx = await MintRedeemPool.collect();
    await collectTx.wait();
    this.CollectedFlg = 'YES';
    return collectTx;
  }

  async quoteFromSpooky(tokenAmount: string, tokenName: string): Promise<string> {
    const { SpookyRouter } = this.contracts;
    const { _reserve0, _reserve1 } = await this.TOMBWFTM_LP.getReserves();
    let quote;
    if (tokenName === 'TOMB') {
      quote = await SpookyRouter.quote(parseUnits(tokenAmount), _reserve1, _reserve0);
    } else {
      quote = await SpookyRouter.quote(parseUnits(tokenAmount), _reserve0, _reserve1);
    }
    return (quote / 1e18).toString();
  }

  async calMintFromFTM(tokenAmount: string): Promise<string> {
    const { MintRedeemPool } = this.contracts;
    let quote = await MintRedeemPool.calcMint(parseUnits(tokenAmount, 18));
    return quote;
  }

  async getPoolInfo(): Promise<PoolInfoStat> {
    const { MintRedeemPool } = this.contracts;
    const quote = await MintRedeemPool.info();
    return quote;
  }

  async getPoolUserInfo(): Promise<PoolUserInfoStat> {
    const { MintRedeemPool } = this.contracts;
    const quote = await MintRedeemPool.userInfo(this.myAccount);
    return quote;
  }

  async calRedeemFromBNBX(tokenAmount: string): Promise<string> {
    const { MintRedeemPool } = this.contracts;
    let quote;
    // let { _ethOut, _yTokenOutSpot , _yTokenOutTwap, _ethFee ,  _requiredEthBalance } = await MintRedeemPool.calcRedeem( String(tokenAmount) );
    quote = await MintRedeemPool.calcRedeem(parseUnits(tokenAmount, 18));
    return quote;
  }

  /**
   * @returns an array of the regulation events till the most up to date epoch
   */
  async listenForRegulationsEvents(): Promise<any> {
    const { Treasury } = this.contracts;

    const treasuryDaoFundedFilter = Treasury.filters.DaoFundFunded();
    const treasuryDevFundedFilter = Treasury.filters.DevFundFunded();
    const treasuryMasonryFundedFilter = Treasury.filters.MasonryFunded();
    const boughtBondsFilter = Treasury.filters.BoughtBonds();
    const redeemBondsFilter = Treasury.filters.RedeemedBonds();

    let epochBlocksRanges: any[] = [];
    let masonryFundEvents = await Treasury.queryFilter(treasuryMasonryFundedFilter);
    var events: any[] = [];
    masonryFundEvents.forEach(function callback(value, index) {
      events.push({ epoch: index + 1 });
      events[index].masonryFund = getDisplayBalance(value.args[1]);
      if (index === 0) {
        epochBlocksRanges.push({
          index: index,
          startBlock: value.blockNumber,
          boughBonds: 0,
          redeemedBonds: 0,
        });
      }
      if (index > 0) {
        epochBlocksRanges.push({
          index: index,
          startBlock: value.blockNumber,
          boughBonds: 0,
          redeemedBonds: 0,
        });
        epochBlocksRanges[index - 1].endBlock = value.blockNumber;
      }
    });

    epochBlocksRanges.forEach(async (value, index) => {
      events[index].bondsBought = await this.getBondsWithFilterForPeriod(
        boughtBondsFilter,
        value.startBlock,
        value.endBlock,
      );
      events[index].bondsRedeemed = await this.getBondsWithFilterForPeriod(
        redeemBondsFilter,
        value.startBlock,
        value.endBlock,
      );
    });
    let DEVFundEvents = await Treasury.queryFilter(treasuryDevFundedFilter);
    DEVFundEvents.forEach(function callback(value, index) {
      events[index].devFund = getDisplayBalance(value.args[1]);
    });
    let DAOFundEvents = await Treasury.queryFilter(treasuryDaoFundedFilter);
    DAOFundEvents.forEach(function callback(value, index) {
      events[index].daoFund = getDisplayBalance(value.args[1]);
    });
    return events;
  }

  /**
   * Helper method
   * @param filter applied on the query to the treasury events
   * @param from block number
   * @param to block number
   * @returns the amount of bonds events emitted based on the filter provided during a specific period
   */
  async getBondsWithFilterForPeriod(filter: EventFilter, from: number, to: number): Promise<number> {
    const { Treasury } = this.contracts;
    const bondsAmount = await Treasury.queryFilter(filter, from, to);
    return bondsAmount.length;
  }

  async estimateZapIn(tokenName: string, lpName: string, amount: string): Promise<number[]> {
    const { zapper } = this.contracts;
    const lpToken = this.externalTokens[lpName];
    let estimate;
    if (tokenName === FTM_TICKER) {
      estimate = await zapper.estimateZapIn(lpToken.address, SPOOKY_ROUTER_ADDR, parseUnits(amount, 18));
    } else {
      const token = tokenName === TOMB_TICKER ? this.TOMB : this.TSHARE;
      estimate = await zapper.estimateZapInToken(
        token.address,
        lpToken.address,
        SPOOKY_ROUTER_ADDR,
        parseUnits(amount, 18),
      );
    }
    return [estimate[0] / 1e18, estimate[1] / 1e18];
  }
  async zapIn(tokenName: string, lpName: string, amount: string): Promise<TransactionResponse> {
    const { zapper } = this.contracts;
    const lpToken = this.externalTokens[lpName];
    if (tokenName === FTM_TICKER) {
      let overrides = {
        value: parseUnits(amount, 18),
      };
      return await zapper.zapIn(lpToken.address, SPOOKY_ROUTER_ADDR, this.myAccount, overrides);
    } else {
      const token = tokenName === TOMB_TICKER ? this.TOMB : this.TSHARE;
      return await zapper.zapInToken(
        token.address,
        parseUnits(amount, 18),
        lpToken.address,
        SPOOKY_ROUTER_ADDR,
        this.myAccount,
      );
    }
  }

  async zapOn(ftmamount: string, pid: number, mimLPamount: number): Promise<TransactionResponse> {
    const { zapper } = this.contracts;
    // if (tokenName === FTM_TICKER) {
    //   let overrides = {
    //     value: parseUnits(amount, 18),
    //   };  0 34351846283814624
    console.log('Herea', zapper, String(pid), String(mimLPamount), ethers.utils.parseUnits(ftmamount, 'ether'));
    return await zapper.zap(String(pid), '0', '1', {
      value: ethers.utils.parseUnits(ftmamount, 'ether'),
    });
  }

  async swapTBondToTShare(tbondAmount: BigNumber): Promise<TransactionResponse> {
    const { TShareSwapper } = this.contracts;
    return await TShareSwapper.swapTBondToTShare(tbondAmount);
  }
  async estimateAmountOfTShare(tbondAmount: string): Promise<string> {
    const { TShareSwapper } = this.contracts;
    try {
      const estimateBN = await TShareSwapper.estimateAmountOfTShare(parseUnits(tbondAmount, 18));
      return getDisplayBalance(estimateBN, 18, 6);
    } catch (err) {
      console.error(`Failed to fetch estimate tshare amount: ${err}`);
    }
  }

  async getTShareSwapperStat(address: string): Promise<TShareSwapperStat> {
    const { TShareSwapper } = this.contracts;
    const tshareBalanceBN = await TShareSwapper.getTShareBalance();
    const tbondBalanceBN = await TShareSwapper.getTBondBalance(address);
    // const tombPriceBN = await TShareSwapper.getTombPrice();
    // const tsharePriceBN = await TShareSwapper.getTSharePrice();
    const rateTSharePerTombBN = await TShareSwapper.getTShareAmountPerTomb();
    const tshareBalance = getDisplayBalance(tshareBalanceBN, 18, 5);
    const tbondBalance = getDisplayBalance(tbondBalanceBN, 18, 5);
    return {
      tshareBalance: tshareBalance.toString(),
      tbondBalance: tbondBalance.toString(),
      // tombPrice: tombPriceBN.toString(),
      // tsharePrice: tsharePriceBN.toString(),
      rateTSharePerTomb: rateTSharePerTombBN.toString(),
    };
  }

  async getTitanoStat(tokenName: string): Promise<TokenStat> {
    const supply = await this.externalTokens[tokenName].totalSupply();
    const priceInBNB = await this.getTokenPriceFromPancakeswap(this.externalTokens[tokenName]);
    const priceOfOneBNB = await this.getWFTMPriceFromPancakeswap();
    const priceOfTITANOInDollars = (Number(priceInBNB) * Number(priceOfOneBNB)).toFixed(18);

    return {
      tokenInFtm: priceInBNB,
      priceInDollars: priceOfTITANOInDollars,
      totalSupply: getDisplayBalance(supply, this.externalTokens[tokenName].decimal, 0),
      circulatingSupply: '0',
    };
  }

  async getStatsRoll(tokenName: string): Promise<RollStats> {
    const { TitanoRoll } = this.contracts;
    const totalBetAmount = await TitanoRoll.totalBetAmount(this.externalTokens[tokenName].address);
    const totalBetAmount_ = getDisplayBalance(totalBetAmount, this.externalTokens[tokenName].decimal, 0);
    const totalsBets = await TitanoRoll.getTotalBets();
    const totalsBets_ = getDisplayBalance(totalsBets, 0, 2);
    const tokensMinBetAmount = await TitanoRoll.tokensMinBetAmount(this.externalTokens[tokenName].address);
    const tokensMinBetAmount_ = getDisplayBalance(tokensMinBetAmount, this.externalTokens[tokenName].decimal, 0);
    const tokensMaxBetAmount = await TitanoRoll.tokensMaxBetAmount(this.externalTokens[tokenName].address);
    const tokensMaxBetAmount_ = getDisplayBalance(tokensMaxBetAmount, this.externalTokens[tokenName].decimal, 0);
    return {
      totalBetAmount: totalBetAmount_.toString(),
      totalsBets: totalsBets_.toString(),
      tokensMinBetAmount: tokensMinBetAmount_.toString(),
      tokensMaxBetAmount: tokensMaxBetAmount_.toString(),
    };
  }

  async getStatsToss(tokenName: string): Promise<TossStats> {
    const { TitanoToss } = this.contracts;
    const totalBetAmount = await TitanoToss.totalBetAmount(this.externalTokens[tokenName].address);
    const totalBetAmount_ = getDisplayBalance(totalBetAmount, this.externalTokens[tokenName].decimal, 0);
    const totalsBets = await TitanoToss.getTotalBets();
    const totalsBets_ = getDisplayBalance(totalsBets, 0, 2);
    const tokensMinBetAmount = await TitanoToss.tokensMinBetAmount(this.externalTokens[tokenName].address);
    const tokensMinBetAmount_ = getDisplayBalance(tokensMinBetAmount, this.externalTokens[tokenName].decimal, 0);
    const tokensMaxBetAmount = await TitanoToss.tokensMaxBetAmount(this.externalTokens[tokenName].address);
    const tokensMaxBetAmount_ = getDisplayBalance(tokensMaxBetAmount, this.externalTokens[tokenName].decimal, 0);
    return {
      totalBetAmount: totalBetAmount_.toString(),
      totalsBets: totalsBets_.toString(),
      tokensMinBetAmount: tokensMinBetAmount_.toString(),
      tokensMaxBetAmount: tokensMaxBetAmount_.toString(),
    };
  }

  async getStatsRollHistory(tokenName: string): Promise<RollStatsHistory> {
    const { TitanoRoll } = this.contracts;
    const totalsBets = Number(await TitanoRoll.getTotalBets());
    const betsHistory = [];
    for (let index = totalsBets - 1; index >= (totalsBets > 20 ? totalsBets - 20 : 0); index--) {
      const randomNumber = await TitanoRoll.betResults(index);
      const resultData = await TitanoRoll.bets(randomNumber.toString());
      const diceBets = await TitanoRoll.diceBets(randomNumber.toString());
      const diceBets2 = await TitanoRoll.diceBets2(randomNumber.toString());
      const betHistory = {
        address: resultData.user.toString(),
        player: `${resultData.user.substring(0, 5)}...${resultData.user.substring(resultData.user.length - 4)}`,
        amount: `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 0 }).format(
          Number(getDisplayBalance(resultData.amount, this.externalTokens[tokenName].decimal, 0).toString()),
        )}`,
        range: `${diceBets}-${diceBets2}`,
        result: resultData.rolled.toString() !== '101' ? resultData.rolled.toString() : 'Pending',
        payout: resultData.result
          ? `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 0 }).format(
              Number(getDisplayBalance(resultData.payout, this.externalTokens[tokenName].decimal, 0)),
            )}`
          : `0`,
        randomNumber: randomNumber.toString(),
        token: resultData.token.toString(),
        betResult: resultData.result,
      };
      betsHistory.push(betHistory);
    }
    return betsHistory;
  }

  async getStatsTossHistory(tokenName: string): Promise<TossStatsHistory> {
    const { TitanoToss } = this.contracts;
    const totalsBets = Number(await TitanoToss.getTotalBets());
    const betsHistory = [];
    for (let index = totalsBets - 1; index >= (totalsBets > 20 ? totalsBets - 20 : 0); index--) {
      const randomNumber = await TitanoToss.betResults(index);
      const resultData = await TitanoToss.bets(randomNumber.toString());
      const diceBets = await TitanoToss.diceBets(randomNumber.toString());
      const betHistory = {
        address: resultData.user.toString(),
        player: `${resultData.user.substring(0, 5)}...${resultData.user.substring(resultData.user.length - 4)}`,
        amount: `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 0 }).format(
          Number(getDisplayBalance(resultData.amount, this.externalTokens[tokenName].decimal, 0).toString()),
        )}`,
        range: `${diceBets.toString() === '0' ? `Tails` : `Heads`}`,
        result:
          resultData.rolled.toString() !== '2' ? (resultData.rolled.toString() === '1' ? 'Heads' : 'Tails') : 'Pending',
        payout: resultData.result
          ? `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 0 }).format(
              Number(getDisplayBalance(resultData.payout, this.externalTokens[tokenName].decimal, 0)),
            )}`
          : `0`,
        randomNumber: randomNumber.toString(),
        token: resultData.token.toString(),
        betResult: resultData.result,
      };
      betsHistory.push(betHistory);
    }
    return betsHistory;
  }

  async roll(cap1: Number, cap2: Number, address: string, amount: BigNumber): Promise<TransactionResponse> {
    const { TitanoRoll } = this.contracts;
    return await TitanoRoll.wager(cap1, cap2, address, amount, { value: 5000000000000000 });
  }

  async toss(cap: Number, address: string, amount: BigNumber): Promise<TransactionResponse> {
    const { TitanoToss } = this.contracts;
    return await TitanoToss.wager(cap, address, amount, { value: 5000000000000000 });
  }
}
